import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {BreadCrumb} from '@pt/pt-models';
import {buildBreadCrumb} from "../../utils";
import {distinctUntilChanged, filter} from "rxjs/operators";
import {NgrxCoreReducer, PtCoreActions} from "@pt/pt-core";
import {Store} from "@ngrx/store";

@Component({
  selector: 'pt-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  breadcrumbs: BreadCrumb[] = [];

  constructor(private activatedRoute: ActivatedRoute,
              private store: Store<NgrxCoreReducer.CoreState>,
              private router: Router) {
  }

  navigate(url: string) {
    if (url !== null && url !== undefined) {
      this.router.navigate(url.split('/')).then();
    }
  }

  ngOnInit(): void {
    this.loadBreadCrumbAndProcessUrl();
  }

  private loadBreadCrumbAndProcessUrl() {
    this.breadcrumbs = buildBreadCrumb(this.activatedRoute.root);
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      distinctUntilChanged()
    ).subscribe(() => {
      this.breadcrumbs = buildBreadCrumb(this.activatedRoute.root);
      this.store.dispatch(PtCoreActions.closeSessionNotifications());
    });
  }
}
